import axios from 'axios';

import client from '@/lib/feathers';

const uploads = client.service('uploads');

type OldImage = {
  id: string;
  path: string;
  name: string;
};

type UploadImage = Omit<OldImage, 'id'> & {
  id?: string;
  file?: File;
};

export const handleImageUpload = async (
  oldImage: OldImage | null,
  uploadImage: UploadImage | null
) => {
  const isRemoveOldImage =
    oldImage && (uploadImage === null || uploadImage.file);

  if (isRemoveOldImage) {
    await uploads.remove(oldImage.id);
  }

  if (oldImage && uploadImage === null) {
    return null;
  }

  if (uploadImage?.file) {
    const body = new FormData();
    body.append('files', uploadImage.file);

    const response = await axios('/newUploads?type=communityData', {
      method: 'POST',
      headers: {
        authorization: window.localStorage['feathers-jwt'],
      },
      data: body,
    });
    const { showPath, _id, oldName } = response.data[0];
    return {
      path: showPath,
      name: oldName,
      id: _id,
    };
  }

  return oldImage;
};
